<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/checklist_conclusion_daily_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "sequence",
      "name",
      "is_active",
      "system_class",
      "industry_categories",
      "updated_info",
    ],
    sortBy: "sequence",
  }),
};
</script>

<style>
</style>